function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, u) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = u() : "function" == typeof define && define.amd ? define([], u) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.Banana = u() : e.Banana = u();
}(this, function () {
  return function (e) {
    var u = {};

    function d(t) {
      if (u[t]) return u[t].exports;
      var r = u[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return e[t].call(r.exports, r, r.exports, d), r.l = !0, r.exports;
    }

    return d.m = e, d.c = u, d.d = function (e, u, t) {
      d.o(e, u) || Object.defineProperty(e, u, {
        enumerable: !0,
        get: t
      });
    }, d.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, d.t = function (e, u) {
      if (1 & u && (e = d(e)), 8 & u) return e;
      if (4 & u && "object" == _typeof(e) && e && e.__esModule) return e;
      var t = Object.create(null);
      if (d.r(t), Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
      }), 2 & u && "string" != typeof e) for (var r in e) {
        d.d(t, r, function (u) {
          return e[u];
        }.bind(null, r));
      }
      return t;
    }, d.n = function (e) {
      var u = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return d.d(u, "a", u), u;
    }, d.o = function (e, u) {
      return Object.prototype.hasOwnProperty.call(e, u);
    }, d.p = "", d(d.s = 2);
  }([function (e) {
    e.exports = JSON.parse('{"ar":"٠١٢٣٤٥٦٧٨٩","fa":"۰۱۲۳۴۵۶۷۸۹","ml":"൦൧൨൩൪൫൬൭൮൯","kn":"೦೧೨೩೪೫೬೭೮೯","lo":"໐໑໒໓໔໕໖໗໘໙","or":"୦୧୨୩୪୫୬୭୮୯","kh":"០១២៣៤៥៦៧៨៩","nqo":"߀߁߂߃߄߅߆߇߈߉","pa":"੦੧੨੩੪੫੬੭੮੯","gu":"૦૧૨૩૪૫૬૭૮૯","hi":"०१२३४५६७८९","my":"၀၁၂၃၄၅၆၇၈၉","ta":"௦௧௨௩௪௫௬௭௮௯","te":"౦౧౨౩౪౫౬౭౮౯","th":"๐๑๒๓๔๕๖๗๘๙","bo":"༠༡༢༣༤༥༦༧༨༩"}');
  }, function (e) {
    e.exports = JSON.parse('{"ab":["ru"],"ace":["id"],"aln":["sq"],"als":["gsw","de"],"an":["es"],"anp":["hi"],"arn":["es"],"arz":["ar"],"av":["ru"],"ay":["es"],"ba":["ru"],"bar":["de"],"bat-smg":["sgs","lt"],"bcc":["fa"],"be-x-old":["be-tarask"],"bh":["bho"],"bjn":["id"],"bm":["fr"],"bpy":["bn"],"bqi":["fa"],"bug":["id"],"cbk-zam":["es"],"ce":["ru"],"crh":["crh-latn"],"crh-cyrl":["ru"],"csb":["pl"],"cv":["ru"],"de-at":["de"],"de-ch":["de"],"de-formal":["de"],"dsb":["de"],"dtp":["ms"],"egl":["it"],"eml":["it"],"ff":["fr"],"fit":["fi"],"fiu-vro":["vro","et"],"frc":["fr"],"frp":["fr"],"frr":["de"],"fur":["it"],"gag":["tr"],"gan":["gan-hant","zh-hant","zh-hans"],"gan-hans":["zh-hans"],"gan-hant":["zh-hant","zh-hans"],"gl":["pt"],"glk":["fa"],"gn":["es"],"gsw":["de"],"hif":["hif-latn"],"hsb":["de"],"ht":["fr"],"ii":["zh-cn","zh-hans"],"inh":["ru"],"iu":["ike-cans"],"jut":["da"],"jv":["id"],"kaa":["kk-latn","kk-cyrl"],"kbd":["kbd-cyrl"],"khw":["ur"],"kiu":["tr"],"kk":["kk-cyrl"],"kk-arab":["kk-cyrl"],"kk-latn":["kk-cyrl"],"kk-cn":["kk-arab","kk-cyrl"],"kk-kz":["kk-cyrl"],"kk-tr":["kk-latn","kk-cyrl"],"kl":["da"],"ko-kp":["ko"],"koi":["ru"],"krc":["ru"],"ks":["ks-arab"],"ksh":["de"],"ku":["ku-latn"],"ku-arab":["ckb"],"kv":["ru"],"lad":["es"],"lb":["de"],"lbe":["ru"],"lez":["ru"],"li":["nl"],"lij":["it"],"liv":["et"],"lmo":["it"],"ln":["fr"],"ltg":["lv"],"lzz":["tr"],"mai":["hi"],"map-bms":["jv","id"],"mg":["fr"],"mhr":["ru"],"min":["id"],"mo":["ro"],"mrj":["ru"],"mwl":["pt"],"myv":["ru"],"mzn":["fa"],"nah":["es"],"nap":["it"],"nds":["de"],"nds-nl":["nl"],"nl-informal":["nl"],"no":["nb"],"os":["ru"],"pcd":["fr"],"pdc":["de"],"pdt":["de"],"pfl":["de"],"pms":["it"],"pt":["pt-br"],"pt-br":["pt"],"qu":["es"],"qug":["qu","es"],"rgn":["it"],"rmy":["ro"],"roa-rup":["rup"],"rue":["uk","ru"],"ruq":["ruq-latn","ro"],"ruq-cyrl":["mk"],"ruq-latn":["ro"],"sa":["hi"],"sah":["ru"],"scn":["it"],"sg":["fr"],"sgs":["lt"],"sli":["de"],"sr":["sr-ec"],"srn":["nl"],"stq":["de"],"su":["id"],"szl":["pl"],"tcy":["kn"],"tg":["tg-cyrl"],"tt":["tt-cyrl","ru"],"tt-cyrl":["ru"],"ty":["fr"],"udm":["ru"],"ug":["ug-arab"],"uk":["ru"],"vec":["it"],"vep":["et"],"vls":["nl"],"vmf":["de"],"vot":["fi"],"vro":["et"],"wa":["fr"],"wo":["fr"],"wuu":["zh-hans"],"xal":["ru"],"xmf":["ka"],"yi":["he"],"za":["zh-hans"],"zea":["nl"],"zh":["zh-hans"],"zh-classical":["lzh"],"zh-cn":["zh-hans"],"zh-hant":["zh-hans"],"zh-hk":["zh-hant","zh-hans"],"zh-min-nan":["nan"],"zh-mo":["zh-hk","zh-hant","zh-hans"],"zh-my":["zh-sg","zh-hans"],"zh-sg":["zh-hans"],"zh-tw":["zh-hant","zh-hans"],"zh-yue":["yue"]}');
  }, function (e, u, d) {
    "use strict";

    d.r(u), d.d(u, "default", function () {
      return o;
    });
    var t = d(0);

    var r = /*#__PURE__*/function () {
      function r(e) {
        _classCallCheck(this, r);

        this.locale = e;
      }

      _createClass(r, [{
        key: "convertPlural",
        value: function convertPlural(e, u) {
          var d = new RegExp("\\d+=", "i");
          if (!u || 0 === u.length) return "";

          for (var _t = 0; _t < u.length; _t++) {
            var _r4 = u[_t];

            if (d.test(_r4)) {
              if (parseInt(_r4.slice(0, _r4.indexOf("=")), 10) === e) return _r4.slice(_r4.indexOf("=") + 1);
              u[_t] = void 0;
            }
          }

          u = u.filter(function (e) {
            return !!e;
          });
          var t = this.getPluralForm(e, this.locale);
          return t = Math.min(t, u.length - 1), u[t];
        }
      }, {
        key: "getPluralForm",
        value: function getPluralForm(e, u) {
          var d = new Intl.PluralRules(u),
              t = d.resolvedOptions().pluralCategories,
              _r2 = d.select(e);

          return ["zero", "one", "two", "few", "many", "other"].filter(function (e) {
            return t.includes(e);
          }).indexOf(_r2);
        }
      }, {
        key: "convertNumber",
        value: function convertNumber(e, u) {
          var d = this.digitTransformTable(this.locale),
              t = String(e),
              _r3 = "";
          if (!d) return e;

          if (u) {
            if (parseFloat(e, 10) === e) return e;
            var _u = [];

            for (var _e in d) {
              _u[d[_e]] = _e;
            }

            d = _u;
          }

          for (var _e2 = 0; _e2 < t.length; _e2++) {
            d[t[_e2]] ? _r3 += d[t[_e2]] : _r3 += t[_e2];
          }

          return u ? parseFloat(_r3, 10) : _r3;
        }
      }, {
        key: "convertGrammar",
        value: function convertGrammar(e, u) {
          return e;
        }
      }, {
        key: "gender",
        value: function gender(e, u) {
          if (!u || 0 === u.length) return "";

          for (; u.length < 2;) {
            u.push(u[u.length - 1]);
          }

          return "male" === e ? u[0] : "female" === e ? u[1] : 3 === u.length ? u[2] : u[0];
        }
      }, {
        key: "digitTransformTable",
        value: function digitTransformTable(e) {
          return !!t[e] && t[e].split("");
        }
      }]);

      return r;
    }();

    var n = {
      bs: /*#__PURE__*/function (_r5) {
        _inherits(bs, _r5);

        var _super = _createSuper(bs);

        function bs() {
          _classCallCheck(this, bs);

          return _super.apply(this, arguments);
        }

        _createClass(bs, [{
          key: "convertGrammar",
          value: function convertGrammar(e, u) {
            switch (u) {
              case "instrumental":
                e = "s " + e;
                break;

              case "lokativ":
                e = "o " + e;
            }

            return e;
          }
        }]);

        return bs;
      }(r),
      default: r,
      dsb: /*#__PURE__*/function (_r6) {
        _inherits(dsb, _r6);

        var _super2 = _createSuper(dsb);

        function dsb() {
          _classCallCheck(this, dsb);

          return _super2.apply(this, arguments);
        }

        _createClass(dsb, [{
          key: "convertGrammar",
          value: function convertGrammar(e, u) {
            switch (u) {
              case "instrumental":
                e = "z " + e;
                break;

              case "lokatiw":
                e = "wo " + e;
            }

            return e;
          }
        }]);

        return dsb;
      }(r),
      fi: /*#__PURE__*/function (_r7) {
        _inherits(fi, _r7);

        var _super3 = _createSuper(fi);

        function fi() {
          _classCallCheck(this, fi);

          return _super3.apply(this, arguments);
        }

        _createClass(fi, [{
          key: "convertGrammar",
          value: function convertGrammar(e, u) {
            var d = e.match(/[aou][^äöy]*$/i),
                t = e;

            switch (e.match(/wiki$/i) && (d = !1), e.match(/[bcdfghjklmnpqrstvwxz]$/i) && (e += "i"), u) {
              case "genitive":
                e += "n";
                break;

              case "elative":
                e += d ? "sta" : "stä";
                break;

              case "partitive":
                e += d ? "a" : "ä";
                break;

              case "illative":
                e += e.slice(-1) + "n";
                break;

              case "inessive":
                e += d ? "ssa" : "ssä";
                break;

              default:
                e = t;
            }

            return e;
          }
        }]);

        return fi;
      }(r),
      ga: /*#__PURE__*/function (_r8) {
        _inherits(ga, _r8);

        var _super4 = _createSuper(ga);

        function ga() {
          _classCallCheck(this, ga);

          return _super4.apply(this, arguments);
        }

        _createClass(ga, [{
          key: "convertGrammar",
          value: function convertGrammar(e, u) {
            if ("ainmlae" === u) switch (e) {
              case "an Domhnach":
                e = "Dé Domhnaigh";
                break;

              case "an Luan":
                e = "Dé Luain";
                break;

              case "an Mháirt":
                e = "Dé Mháirt";
                break;

              case "an Chéadaoin":
                e = "Dé Chéadaoin";
                break;

              case "an Déardaoin":
                e = "Déardaoin";
                break;

              case "an Aoine":
                e = "Dé hAoine";
                break;

              case "an Satharn":
                e = "Dé Sathairn";
            }
            return e;
          }
        }]);

        return ga;
      }(r),
      he: /*#__PURE__*/function (_r9) {
        _inherits(he, _r9);

        var _super5 = _createSuper(he);

        function he() {
          _classCallCheck(this, he);

          return _super5.apply(this, arguments);
        }

        _createClass(he, [{
          key: "convertGrammar",
          value: function convertGrammar(e, u) {
            switch (u) {
              case "prefixed":
              case "תחילית":
                "ו" === e.slice(0, 1) && "וו" !== e.slice(0, 2) && (e = "ו" + e), "ה" === e.slice(0, 1) && (e = e.slice(1)), (e.slice(0, 1) < "א" || e.slice(0, 1) > "ת") && (e = "־" + e);
            }

            return e;
          }
        }]);

        return he;
      }(r),
      hsb: /*#__PURE__*/function (_r10) {
        _inherits(hsb, _r10);

        var _super6 = _createSuper(hsb);

        function hsb() {
          _classCallCheck(this, hsb);

          return _super6.apply(this, arguments);
        }

        _createClass(hsb, [{
          key: "convertGrammar",
          value: function convertGrammar(e, u) {
            switch (u) {
              case "instrumental":
                e = "z " + e;
                break;

              case "lokatiw":
                e = "wo " + e;
            }

            return e;
          }
        }]);

        return hsb;
      }(r),
      hu: /*#__PURE__*/function (_r11) {
        _inherits(hu, _r11);

        var _super7 = _createSuper(hu);

        function hu() {
          _classCallCheck(this, hu);

          return _super7.apply(this, arguments);
        }

        _createClass(hu, [{
          key: "convertGrammar",
          value: function convertGrammar(e, u) {
            switch (u) {
              case "rol":
                e += "ról";
                break;

              case "ba":
                e += "ba";
                break;

              case "k":
                e += "k";
            }

            return e;
          }
        }]);

        return hu;
      }(r),
      hy: /*#__PURE__*/function (_r12) {
        _inherits(hy, _r12);

        var _super8 = _createSuper(hy);

        function hy() {
          _classCallCheck(this, hy);

          return _super8.apply(this, arguments);
        }

        _createClass(hy, [{
          key: "convertGrammar",
          value: function convertGrammar(e, u) {
            return "genitive" === u && ("ա" === e.slice(-1) ? e = e.slice(0, -1) + "այի" : "ո" === e.slice(-1) ? e = e.slice(0, -1) + "ոյի" : "գիրք" === e.slice(-4) ? e = e.slice(0, -4) + "գրքի" : e += "ի"), e;
          }
        }]);

        return hy;
      }(r),
      la: /*#__PURE__*/function (_r13) {
        _inherits(la, _r13);

        var _super9 = _createSuper(la);

        function la() {
          _classCallCheck(this, la);

          return _super9.apply(this, arguments);
        }

        _createClass(la, [{
          key: "convertGrammar",
          value: function convertGrammar(e, u) {
            switch (u) {
              case "genitive":
                e = (e = (e = (e = (e = (e = (e = (e = (e = e.replace(/u[ms]$/i, "i")).replace(/ommunia$/i, "ommunium")).replace(/a$/i, "ae")).replace(/libri$/i, "librorum")).replace(/nuntii$/i, "nuntiorum")).replace(/tio$/i, "tionis")).replace(/ns$/i, "ntis")).replace(/as$/i, "atis")).replace(/es$/i, "ei");
                break;

              case "accusative":
                e = (e = (e = (e = (e = (e = (e = (e = (e = e.replace(/u[ms]$/i, "um")).replace(/ommunia$/i, "am")).replace(/a$/i, "ommunia")).replace(/libri$/i, "libros")).replace(/nuntii$/i, "nuntios")).replace(/tio$/i, "tionem")).replace(/ns$/i, "ntem")).replace(/as$/i, "atem")).replace(/es$/i, "em");
                break;

              case "ablative":
                e = (e = (e = (e = (e = (e = (e = (e = (e = e.replace(/u[ms]$/i, "o")).replace(/ommunia$/i, "ommunibus")).replace(/a$/i, "a")).replace(/libri$/i, "libris")).replace(/nuntii$/i, "nuntiis")).replace(/tio$/i, "tione")).replace(/ns$/i, "nte")).replace(/as$/i, "ate")).replace(/es$/i, "e");
            }

            return e;
          }
        }]);

        return la;
      }(r),
      os: /*#__PURE__*/function (_r14) {
        _inherits(os, _r14);

        var _super10 = _createSuper(os);

        function os() {
          _classCallCheck(this, os);

          return _super10.apply(this, arguments);
        }

        _createClass(os, [{
          key: "convertGrammar",
          value: function convertGrammar(e, u) {
            var d, t, r, n;

            switch (d = "мæ", t = "", r = "", n = "", e.match(/тæ$/i) ? (e = e.slice(0, -1), d = "æм") : e.match(/[аæеёиоыэюя]$/i) ? t = "й" : e.match(/у$/i) ? e.slice(-2, -1).match(/[аæеёиоыэюя]$/i) || (t = "й") : e.match(/[бвгджзйклмнопрстфхцчшщьъ]$/i) || (r = "-"), u) {
              case "genitive":
                n = r + t + "ы";
                break;

              case "dative":
                n = r + t + "æн";
                break;

              case "allative":
                n = r + d;
                break;

              case "ablative":
                n = "й" === t ? r + t + "æ" : r + t + "æй";
                break;

              case "superessive":
                n = r + t + "ыл";
                break;

              case "equative":
                n = r + t + "ау";
                break;

              case "comitative":
                n = r + "имæ";
            }

            return e + n;
          }
        }]);

        return os;
      }(r),
      ru: /*#__PURE__*/function (_r15) {
        _inherits(ru, _r15);

        var _super11 = _createSuper(ru);

        function ru() {
          _classCallCheck(this, ru);

          return _super11.apply(this, arguments);
        }

        _createClass(ru, [{
          key: "convertGrammar",
          value: function convertGrammar(e, u) {
            return "genitive" === u && ("ь" === e.slice(-1) ? e = e.slice(0, -1) + "я" : "ия" === e.slice(-2) ? e = e.slice(0, -2) + "ии" : "ка" === e.slice(-2) ? e = e.slice(0, -2) + "ки" : "ти" === e.slice(-2) ? e = e.slice(0, -2) + "тей" : "ды" === e.slice(-2) ? e = e.slice(0, -2) + "дов" : "ник" === e.slice(-3) && (e = e.slice(0, -3) + "ника")), e;
          }
        }]);

        return ru;
      }(r),
      sl: /*#__PURE__*/function (_r16) {
        _inherits(sl, _r16);

        var _super12 = _createSuper(sl);

        function sl() {
          _classCallCheck(this, sl);

          return _super12.apply(this, arguments);
        }

        _createClass(sl, [{
          key: "convertGrammar",
          value: function convertGrammar(e, u) {
            switch (u) {
              case "mestnik":
                e = "o " + e;
                break;

              case "orodnik":
                e = "z " + e;
            }

            return e;
          }
        }]);

        return sl;
      }(r),
      uk: /*#__PURE__*/function (_r17) {
        _inherits(uk, _r17);

        var _super13 = _createSuper(uk);

        function uk() {
          _classCallCheck(this, uk);

          return _super13.apply(this, arguments);
        }

        _createClass(uk, [{
          key: "convertGrammar",
          value: function convertGrammar(e, u) {
            switch (u) {
              case "genitive":
                "ь" === e.slice(-1) ? e = e.slice(0, -1) + "я" : "ія" === e.slice(-2) ? e = e.slice(0, -2) + "ії" : "ка" === e.slice(-2) ? e = e.slice(0, -2) + "ки" : "ти" === e.slice(-2) ? e = e.slice(0, -2) + "тей" : "ды" === e.slice(-2) ? e = e.slice(0, -2) + "дов" : "ник" === e.slice(-3) && (e = e.slice(0, -3) + "ника");
                break;

              case "accusative":
                "ія" === e.slice(-2) && (e = e.slice(0, -2) + "ію");
            }

            return e;
          }
        }]);

        return uk;
      }(r)
    };
    var a = new RegExp("(?:([A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02BB-\u02C1\u02D0\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0482\u048A-\u052F\u0531-\u0556\u0559-\u055F\u0561-\u0587\u0589\u0903-\u0939\u093B\u093D-\u0940\u0949-\u094C\u094E-\u0950\u0958-\u0961\u0964-\u0980\u0982\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD-\u09C0\u09C7\u09C8\u09CB\u09CC\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09FA\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD-\u0AC0\u0AC9\u0ACB\u0ACC\u0AD0\u0AE0\u0AE1\u0AE6-\u0AF0\u0AF9\u0B02\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0B57\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7\u0BE6-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C5A\u0C60\u0C61\u0C66-\u0C6F\u0C7F\u0C82\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD-\u0CC4\u0CC6-\u0CC8\u0CCA\u0CCB\u0CD5\u0CD6\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D02\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D5F-\u0D61\u0D66-\u0D75\u0D79-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2-\u0DF4\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E4F-\u0E5B\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00-\u0F17\u0F1A-\u0F34\u0F36\u0F38\u0F3E-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FDA\u1000-\u102C\u1031\u1038\u103B\u103C\u103F-\u1057\u105A-\u105D\u1061-\u1070\u1075-\u1081\u1083\u1084\u1087-\u108C\u108E-\u109C\u109E-\u10C5\u10C7\u10CD\u10D0-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u167F\u1681-\u169A\u16A0-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735\u1736\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5\u17C7\u17C8\u17D4-\u17DA\u17DC\u17E0-\u17E9\u1810-\u1819\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A19\u1A1A\u1A1E-\u1A55\u1A57\u1A61\u1A63\u1A64\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AAD\u1B04-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B4B\u1B50-\u1B6A\u1B74-\u1B7C\u1B82-\u1BA1\u1BA6\u1BA7\u1BAA\u1BAE-\u1BE5\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1BFC-\u1C2B\u1C34\u1C35\u1C3B-\u1C49\u1C4D-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u302E\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31F0-\u321C\u3220-\u324F\u3260-\u327B\u327F-\u32B0\u32C0-\u32CB\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA60C\uA610-\uA62B\uA640-\uA66E\uA680-\uA69D\uA6A0-\uA6EF\uA6F2-\uA6F7\uA722-\uA787\uA789-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA824\uA827\uA830-\uA837\uA840-\uA873\uA880-\uA8C3\uA8CE-\uA8D9\uA8F2-\uA8FD\uA900-\uA925\uA92E-\uA946\uA952\uA953\uA95F-\uA97C\uA983-\uA9B2\uA9B4\uA9B5\uA9BA\uA9BB\uA9BD-\uA9CD\uA9CF-\uA9D9\uA9DE-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA2F\uAA30\uAA33\uAA34\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA7B\uAA7D-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAAEB\uAAEE-\uAAF5\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB65\uAB70-\uABE4\uABE6\uABE7\uABE9-\uABEC\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B]|\uD800[\uDC0D-\uDC26]|\uD800[\uDC28-\uDC3A]|\uD800\uDC3C|\uD800\uDC3D|\uD800[\uDC3F-\uDC4D]|\uD800[\uDC50-\uDC5D]|\uD800[\uDC80-\uDCFA]|\uD800\uDD00|\uD800\uDD02|\uD800[\uDD07-\uDD33]|\uD800[\uDD37-\uDD3F]|\uD800[\uDDD0-\uDDFC]|\uD800[\uDE80-\uDE9C]|\uD800[\uDEA0-\uDED0]|\uD800[\uDF00-\uDF23]|\uD800[\uDF30-\uDF4A]|\uD800[\uDF50-\uDF75]|\uD800[\uDF80-\uDF9D]|\uD800[\uDF9F-\uDFC3]|\uD800[\uDFC8-\uDFD5]|\uD801[\uDC00-\uDC9D]|\uD801[\uDCA0-\uDCA9]|\uD801[\uDD00-\uDD27]|\uD801[\uDD30-\uDD63]|\uD801\uDD6F|\uD801[\uDE00-\uDF36]|\uD801[\uDF40-\uDF55]|\uD801[\uDF60-\uDF67]|\uD804\uDC00|\uD804[\uDC02-\uDC37]|\uD804[\uDC47-\uDC4D]|\uD804[\uDC66-\uDC6F]|\uD804[\uDC82-\uDCB2]|\uD804\uDCB7|\uD804\uDCB8|\uD804[\uDCBB-\uDCC1]|\uD804[\uDCD0-\uDCE8]|\uD804[\uDCF0-\uDCF9]|\uD804[\uDD03-\uDD26]|\uD804\uDD2C|\uD804[\uDD36-\uDD43]|\uD804[\uDD50-\uDD72]|\uD804[\uDD74-\uDD76]|\uD804[\uDD82-\uDDB5]|\uD804[\uDDBF-\uDDC9]|\uD804\uDDCD|\uD804[\uDDD0-\uDDDF]|\uD804[\uDDE1-\uDDF4]|\uD804[\uDE00-\uDE11]|\uD804[\uDE13-\uDE2E]|\uD804\uDE32|\uD804\uDE33|\uD804\uDE35|\uD804[\uDE38-\uDE3D]|\uD804[\uDE80-\uDE86]|\uD804\uDE88|\uD804[\uDE8A-\uDE8D]|\uD804[\uDE8F-\uDE9D]|\uD804[\uDE9F-\uDEA9]|\uD804[\uDEB0-\uDEDE]|\uD804[\uDEE0-\uDEE2]|\uD804[\uDEF0-\uDEF9]|\uD804\uDF02|\uD804\uDF03|\uD804[\uDF05-\uDF0C]|\uD804\uDF0F|\uD804\uDF10|\uD804[\uDF13-\uDF28]|\uD804[\uDF2A-\uDF30]|\uD804\uDF32|\uD804\uDF33|\uD804[\uDF35-\uDF39]|\uD804[\uDF3D-\uDF3F]|\uD804[\uDF41-\uDF44]|\uD804\uDF47|\uD804\uDF48|\uD804[\uDF4B-\uDF4D]|\uD804\uDF50|\uD804\uDF57|\uD804[\uDF5D-\uDF63]|\uD805[\uDC80-\uDCB2]|\uD805\uDCB9|\uD805[\uDCBB-\uDCBE]|\uD805\uDCC1|\uD805[\uDCC4-\uDCC7]|\uD805[\uDCD0-\uDCD9]|\uD805[\uDD80-\uDDB1]|\uD805[\uDDB8-\uDDBB]|\uD805\uDDBE|\uD805[\uDDC1-\uDDDB]|\uD805[\uDE00-\uDE32]|\uD805\uDE3B|\uD805\uDE3C|\uD805\uDE3E|\uD805[\uDE41-\uDE44]|\uD805[\uDE50-\uDE59]|\uD805[\uDE80-\uDEAA]|\uD805\uDEAC|\uD805\uDEAE|\uD805\uDEAF|\uD805\uDEB6|\uD805[\uDEC0-\uDEC9]|\uD805[\uDF00-\uDF19]|\uD805\uDF20|\uD805\uDF21|\uD805\uDF26|\uD805[\uDF30-\uDF3F]|\uD806[\uDCA0-\uDCF2]|\uD806\uDCFF|\uD806[\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E]|\uD809[\uDC70-\uDC74]|\uD809[\uDC80-\uDD43]|\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38]|\uD81A[\uDE40-\uDE5E]|\uD81A[\uDE60-\uDE69]|\uD81A\uDE6E|\uD81A\uDE6F|\uD81A[\uDED0-\uDEED]|\uD81A\uDEF5|\uD81A[\uDF00-\uDF2F]|\uD81A[\uDF37-\uDF45]|\uD81A[\uDF50-\uDF59]|\uD81A[\uDF5B-\uDF61]|\uD81A[\uDF63-\uDF77]|\uD81A[\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44]|\uD81B[\uDF50-\uDF7E]|\uD81B[\uDF93-\uDF9F]|\uD82C\uDC00|\uD82C\uDC01|\uD82F[\uDC00-\uDC6A]|\uD82F[\uDC70-\uDC7C]|\uD82F[\uDC80-\uDC88]|\uD82F[\uDC90-\uDC99]|\uD82F\uDC9C|\uD82F\uDC9F|\uD834[\uDC00-\uDCF5]|\uD834[\uDD00-\uDD26]|\uD834[\uDD29-\uDD66]|\uD834[\uDD6A-\uDD72]|\uD834\uDD83|\uD834\uDD84|\uD834[\uDD8C-\uDDA9]|\uD834[\uDDAE-\uDDE8]|\uD834[\uDF60-\uDF71]|\uD835[\uDC00-\uDC54]|\uD835[\uDC56-\uDC9C]|\uD835\uDC9E|\uD835\uDC9F|\uD835\uDCA2|\uD835\uDCA5|\uD835\uDCA6|\uD835[\uDCA9-\uDCAC]|\uD835[\uDCAE-\uDCB9]|\uD835\uDCBB|\uD835[\uDCBD-\uDCC3]|\uD835[\uDCC5-\uDD05]|\uD835[\uDD07-\uDD0A]|\uD835[\uDD0D-\uDD14]|\uD835[\uDD16-\uDD1C]|\uD835[\uDD1E-\uDD39]|\uD835[\uDD3B-\uDD3E]|\uD835[\uDD40-\uDD44]|\uD835\uDD46|\uD835[\uDD4A-\uDD50]|\uD835[\uDD52-\uDEA5]|\uD835[\uDEA8-\uDEDA]|\uD835[\uDEDC-\uDF14]|\uD835[\uDF16-\uDF4E]|\uD835[\uDF50-\uDF88]|\uD835[\uDF8A-\uDFC2]|\uD835[\uDFC4-\uDFCB]|\uD836[\uDC00-\uDDFF]|\uD836[\uDE37-\uDE3A]|\uD836[\uDE6D-\uDE74]|\uD836[\uDE76-\uDE83]|\uD836[\uDE85-\uDE8B]|\uD83C[\uDD10-\uDD2E]|\uD83C[\uDD30-\uDD69]|\uD83C[\uDD70-\uDD9A]|\uD83C[\uDDE6-\uDE02]|\uD83C[\uDE10-\uDE3A]|\uD83C[\uDE40-\uDE48]|\uD83C\uDE50|\uD83C\uDE51|[\uD840-\uD868][\uDC00-\uDFFF]|\uD869[\uDC00-\uDED6]|\uD869[\uDF00-\uDFFF]|[\uD86A-\uD86C][\uDC00-\uDFFF]|\uD86D[\uDC00-\uDF34]|\uD86D[\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D]|\uD86E[\uDC20-\uDFFF]|[\uD86F-\uD872][\uDC00-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|[\uDB80-\uDBBE][\uDC00-\uDFFF]|\uDBBF[\uDC00-\uDFFD]|[\uDBC0-\uDBFE][\uDC00-\uDFFF]|\uDBFF[\uDC00-\uDFFD])|([\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05FF\u07C0-\u07EA\u07F4\u07F5\u07FA-\u0815\u081A\u0824\u0828\u082E-\u0858\u085C-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB4F\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u0710\u0712-\u072F\u074B-\u07A5\u07B1-\u07BF\u08A0-\u08E2\uFB50-\uFD3D\uFD40-\uFDCF\uFDF0-\uFDFC\uFDFE\uFDFF\uFE70-\uFEFE]|\uD802[\uDC00-\uDD1E]|\uD802[\uDD20-\uDE00]|\uD802\uDE04|\uD802[\uDE07-\uDE0B]|\uD802[\uDE10-\uDE37]|\uD802[\uDE3B-\uDE3E]|\uD802[\uDE40-\uDEE4]|\uD802[\uDEE7-\uDF38]|\uD802[\uDF40-\uDFFF]|\uD803[\uDC00-\uDE5F]|\uD803[\uDE7F-\uDFFF]|\uD83A[\uDC00-\uDCCF]|\uD83A[\uDCD7-\uDFFF]|\uD83B[\uDC00-\uDDFF]|\uD83B[\uDF00-\uDFFF]|\uD83B[\uDF00-\uDFFF]|\uD83B[\uDF00-\uDFFF]|\uD83B[\uDF00-\uDFFF]|\uD83B[\uDF00-\uDFFF]|\uD83B[\uDF00-\uDFFF]|\uD83B[\uDF00-\uDFFF]|\uD83B[\uDF00-\uDFFF]|\uD83B[\uDF00-\uDFFF]|\uD83B[\uDF00-\uDFFF]|\uD83B[\uDF00-\uDFFF]|\uD83B[\uDF00-\uDFFF]|\uD83B[\uDF00-\uDFFF]|\uD83B[\uDE00-\uDEEF]|\uD83B[\uDEF2-\uDEFF]))");

    var c = /*#__PURE__*/function () {
      function c(e) {
        _classCallCheck(this, c);

        this.locale = e, this.language = new (n[e] || n.default)(e);
      }

      _createClass(c, [{
        key: "emit",
        value: function emit(e, u) {
          var _this = this;

          var d, t, r;

          switch (_typeof(e)) {
            case "string":
            case "number":
              d = e;
              break;

            case "object":
              if (t = e.slice(1).map(function (e) {
                return _this.emit(e, u);
              }), r = e[0].toLowerCase(), "function" != typeof this[r]) throw new Error('unknown operation "' + r + '"');
              d = this[r](t, u);
              break;

            case "undefined":
              d = "";
              break;

            default:
              throw new Error("unexpected type in AST: " + _typeof(e));
          }

          return d;
        }
      }, {
        key: "concat",
        value: function concat(e) {
          var u = "";
          return e.forEach(function (e) {
            u += e;
          }), u;
        }
      }, {
        key: "replace",
        value: function replace(e, u) {
          var d = parseInt(e[0], 10);
          return d < u.length ? u[d] : "$" + (d + 1);
        }
      }, {
        key: "plural",
        value: function plural(e) {
          var u = parseFloat(this.language.convertNumber(e[0], 10)),
              d = e.slice(1);
          return d.length ? this.language.convertPlural(u, d) : "";
        }
      }, {
        key: "gender",
        value: function gender(e) {
          var u = e[0],
              d = e.slice(1);
          return this.language.gender(u, d);
        }
      }, {
        key: "grammar",
        value: function grammar(e) {
          var u = e[0],
              d = e[1];
          return d && u && this.language.convertGrammar(d, u);
        }
      }, {
        key: "wikilink",
        value: function wikilink(e) {
          var u,
              d = e[0];
          ":" === d.charAt(0) && (d = d.slice(1));
          var t = "./" + d;
          return u = 1 === e.length ? d : e[1], "<a href=\"".concat(t, "\" title=\"").concat(d, "\">").concat(u, "</a>");
        }
      }, {
        key: "extlink",
        value: function extlink(e) {
          if (2 !== e.length) throw new Error("Expected two items in the node");
          return "<a href=\"".concat(e[0], "\">").concat(e[1], "</a>");
        }
      }, {
        key: "bidi",
        value: function bidi(e) {
          var u = function (e) {
            var u = e.match(a);
            if (!u) return null;
            if (void 0 === u[2]) return "ltr";
            return "rtl";
          }(e[0]);

          return "ltr" === u ? "‪" + e[0] + "‬" : "rtl" === u ? "‫" + e[0] + "‬" : e[0];
        }
      }]);

      return c;
    }();

    function l(e) {
      var u,
          d,
          t,
          r,
          n,
          a,
          c,
          l = 0;

      function i(e) {
        return function () {
          for (var _u2 = 0; _u2 < e.length; _u2++) {
            var _d = e[_u2]();

            if (null !== _d) return _d;
          }

          return null;
        };
      }

      function s(e) {
        var u = l,
            d = [];

        for (var _t2 = 0; _t2 < e.length; _t2++) {
          var _r18 = e[_t2]();

          if (null === _r18) return l = u, null;
          d.push(_r18);
        }

        return d;
      }

      function f(e, u) {
        return function () {
          var d = l,
              t = [],
              r = u();

          for (; null !== r;) {
            t.push(r), r = u();
          }

          return t.length < e ? (l = d, null) : t;
        };
      }

      function o(u) {
        var d = u.length;
        return function () {
          var t = null;
          return e.slice(l, l + d) === u && (t = u, l += d), t;
        };
      }

      function h(u) {
        return function () {
          var d = e.slice(l).match(u);
          return null === d ? null : (l += d[0].length, d[0]);
        };
      }

      var b = h(/^\s+/),
          m = o("|"),
          p = o(":"),
          k = o("\\"),
          g = h(/^./),
          v = o("$"),
          w = h(/^\d+/),
          z = h(/^[^{}[\]$\\]/),
          $ = h(/^[^{}[\]$\\|]/),
          y = h(/^[^{}[\]$\s]/);
      var x = i([j, y]);

      function j() {
        var e = s([k, g]);
        return null === e ? null : e[1];
      }

      function O() {
        var e = s([v, w]);
        return null === e ? null : ["REPLACE", parseInt(e[1], 10) - 1];
      }

      var M, C;

      function S() {
        var e = s([m, f(0, a)]);
        if (null === e) return null;
        var u = e[1];
        return u.length > 1 ? ["CONCAT"].concat(u) : u[0];
      }

      function A() {
        var e = s([r, p, O]);
        return null === e ? null : [e[0], e[2]];
      }

      function G() {
        var e = s([r, p, a]);
        return null === e ? null : [e[0], e[2]];
      }

      i([j, y]), u = i([j, $]), d = i([j, z]), M = h(/^[ !"$&'()*,./0-9;=?@A-Z^_`a-z~\x80-\xFF+-]+/), C = function C(e) {
        return e.toString();
      }, r = function r() {
        var e = M();
        return null === e ? null : C(e);
      }, t = i([function () {
        var e = s([i([A, G]), f(0, S)]);
        return null === e ? null : e[0].concat(e[1]);
      }, function () {
        var e = s([r, f(0, S)]);
        return null === e ? null : [e[0]].concat(e[1]);
      }]);
      var T = o("{{"),
          E = o("}}"),
          P = o("[["),
          q = o("]]"),
          N = o("["),
          F = o("]");

      function I() {
        var e = s([T, t, E]);
        return null === e ? null : e[1];
      }

      var D = i([function () {
        var e = s([f(1, a), m, f(1, n)]);
        return null === e ? null : [["CONCAT"].concat(e[0]), ["CONCAT"].concat(e[2])];
      }, function () {
        var e = s([f(1, a)]);
        return null === e ? null : [["CONCAT"].concat(e[0])];
      }]);

      function L() {
        var e = null;
        var u = s([P, D, q]);

        if (null !== u) {
          var _d2 = u[1];
          e = ["WIKILINK"].concat(_d2);
        }

        return e;
      }

      function _() {
        var e = null;
        var u = s([N, f(1, R), b, f(1, n), F]);

        if (null !== u) {
          e = ["EXTLINK", 1 === u[1].length ? u[1][0] : ["CONCAT"].concat(u[1]), ["CONCAT"].concat(u[3])];
        }

        return e;
      }

      var R = i([I, O, L, _, function () {
        var e = f(1, x)();
        return null === e ? null : e.join("");
      }]);
      if (n = i([I, O, L, _, function () {
        var e = f(1, d)();
        return null === e ? null : e.join("");
      }]), a = i([I, O, function () {
        var e = f(1, u)();
        return null === e ? null : e.join("");
      }]), c = function () {
        var e = f(0, n)();
        return null === e ? null : ["CONCAT"].concat(e);
      }(), null === c || l !== e.length) throw new Error("Parse error at position " + l.toString() + " in input: " + e);
      return c;
    }

    var i = /*#__PURE__*/function () {
      function i(e) {
        _classCallCheck(this, i);

        this.locale = e, this.emitter = new c(this.locale);
      }

      _createClass(i, [{
        key: "parse",
        value: function parse(e, u) {
          if (e.includes("{{") || e.includes("[")) {
            var _d3 = new l(e);

            return this.emitter.emit(_d3, u);
          }

          return this.simpleParse(e, u);
        }
      }, {
        key: "simpleParse",
        value: function simpleParse(e, u) {
          return e.replace(/\$(\d+)/g, function (e, d) {
            var t = parseInt(d, 10) - 1;
            return void 0 !== u[t] ? u[t] : "$" + d;
          });
        }
      }]);

      return i;
    }();

    var s = /*#__PURE__*/function () {
      function s(e) {
        _classCallCheck(this, s);

        this.sourceMap = new Map();
      }

      _createClass(s, [{
        key: "load",
        value: function load(e, u) {
          if ("object" != _typeof(e)) throw new Error("Invalid message source. Must be an object");

          if (u) {
            if (!/^[a-zA-Z0-9-]+$/.test(u)) throw new Error("Invalid locale " + u);

            for (var _d4 in e) {
              if (0 !== _d4.indexOf("@")) {
                if ("object" == _typeof(e[_d4])) return this.load(e);
                if ("string" != typeof e[_d4]) throw new Error("Invalid message for message ".concat(_d4, " in ").concat(u, " locale."));
                break;
              }
            }

            this.sourceMap.has(u) ? this.sourceMap.set(u, Object.assign(this.sourceMap.get(u), e)) : this.sourceMap.set(u, e);
          } else for (u in e) {
            this.load(e[u], u);
          }
        }
      }, {
        key: "getMessage",
        value: function getMessage(e, u) {
          var d = this.sourceMap.get(u);
          return d ? d[e] : null;
        }
      }, {
        key: "hasLocale",
        value: function hasLocale(e) {
          return this.sourceMap.has(e);
        }
      }]);

      return s;
    }();

    var f = d(1);

    var o = /*#__PURE__*/function () {
      function o(e, u) {
        _classCallCheck(this, o);

        u = u || {}, this.locale = e, this.parser = new i(this.locale), this.messageStore = new s(), u.messages && this.load(u.messages, this.locale), this.finalFallback = u.finalFallback || "en";
      }

      _createClass(o, [{
        key: "load",
        value: function load(e, u) {
          return this.messageStore.load(e, u || this.locale);
        }
      }, {
        key: "i18n",
        value: function i18n(e) {
          for (var _len = arguments.length, u = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            u[_key - 1] = arguments[_key];
          }

          return this.parser.parse(this.getMessage(e), u);
        }
      }, {
        key: "setLocale",
        value: function setLocale(e) {
          this.locale = e, this.parser = new i(this.locale);
        }
      }, {
        key: "getFallbackLocales",
        value: function getFallbackLocales() {
          return [].concat(_toConsumableArray(f[this.locale] || []), [this.finalFallback]);
        }
      }, {
        key: "getMessage",
        value: function getMessage(e) {
          var u = this.locale,
              d = 0;
          var t = this.getFallbackLocales(this.locale);

          for (; u;) {
            var _r19 = u.split("-"),
                _n = _r19.length;

            do {
              var _u3 = _r19.slice(0, _n).join("-"),
                  _d5 = this.messageStore.getMessage(e, _u3);

              if (_d5) return _d5;
              _n--;
            } while (_n);

            u = t[d], d++;
          }

          return e;
        }
      }]);

      return o;
    }();
  }]).default;
});